<template>
  <div class="toolbar-icon">
    <drop-down
      :items="data"
      :visibility="DropDownVisibility"
      :title="$t('title.fill')"
      :active-index="activeIndex"
      @toggle-dropdown="handleDropDownVisibility"
      @item-click="updateActiveIndex"
    >
      <custom-icon :class-name="icons.Fill" />
    </drop-down>
  </div>
</template>
<script>
import { icons } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";
import DropDown from "../../redZone/content/DropDown.vue";
import DesignerMixin from "../DesignerMixin";

export default {
  components: { CustomIcon, DropDown },
  mixins: [DesignerMixin],
  data() {
    return {
      DropDownVisibility: false,
      icons: icons,
      data: [
        {
          id: 1,
          title: this.$t("fill.down"),
          icon: `${icons.DownArrow}`,
          func: () => this.fillDirection("down"),
        },
        {
          id: 2,
          title: this.$t("fill.right"),
          icon: `${icons.RightArrow}`,
          func: () => this.fillDirection("right"),
        },
        {
          id: 3,
          title: this.$t("fill.up"),
          icon: `${icons.UpArrow}`,
          func: () => this.fillDirection("up"),
        },
        {
          id: 4,
          title: this.$t("fill.left"),
          icon: `${icons.LeftArrow}`,
          func: () => this.fillDirection("left"),
        },
        {
          id: 5,
          title: "Series",
          icon: `${icons.Series}`,
          func: this.setSeries,
        },
      ],
      activeIndex: 0,
    };
  },
  methods: {
    setSeries() {
      this.$store.dispatch("views/setSeriesDialogVisibility", true);
    },
    fillDirection(direction) {
      this.$store.dispatch("cells/fillDirection", { range: this.mainRange.range, direction });
    },
    handleDropDownVisibility(visibility) {
      this.DropDownVisibility = visibility;
    },
    callFunc() {
      this.DropDownVisibility = !this.DropDownVisibility;
    },
    updateActiveIndex(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.toolbar_fill {
  padding: 0 0.3rem;
}
</style>
